exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auto-dialer--3kLgUiQlzYQnufdDIsirKb {\n  position: relative;\n  width: 860px;\n  border-radius: 3px;\n  background-color: #fff;\n  margin: auto;\n  padding: 1rem 1.5rem;\n  outline: none;\n}\n\n.auto-dialer--2xHVf8DmLXJZm1TsND6sdD {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 1050;\n  overflow: hidden auto;\n  background: rgba(0, 0, 0, .5);\n}\n\n.auto-dialer--3v1be_WA9tTlULuLu5z2nA {\n  position: relative;\n  margin-bottom: .5em;\n}\n\n.auto-dialer--2RwSUj9VgMra1mWtc-q-Wx {\n  position: absolute;\n  top: 3px;\n  right: 0;\n  width: 2rem;\n  height: 2rem;\n  font-size: 1rem;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  box-sizing: border-box;\n}\n", ""]);

// exports
exports.locals = {
	"dialog": "auto-dialer--3kLgUiQlzYQnufdDIsirKb",
	"dialog": "auto-dialer--3kLgUiQlzYQnufdDIsirKb",
	"underlay": "auto-dialer--2xHVf8DmLXJZm1TsND6sdD",
	"underlay": "auto-dialer--2xHVf8DmLXJZm1TsND6sdD",
	"modalHeader": "auto-dialer--3v1be_WA9tTlULuLu5z2nA",
	"modalHeader": "auto-dialer--3v1be_WA9tTlULuLu5z2nA",
	"closeButton": "auto-dialer--2RwSUj9VgMra1mWtc-q-Wx",
	"closeButton": "auto-dialer--2RwSUj9VgMra1mWtc-q-Wx"
};